import { IconButton, forwardRef } from '@chakra-ui/react';
import React from 'react';
import { ServiceIcon } from './service-icon';
import { ThemeTokens } from '../../theme/tokens';

type ServiceIconProps = {
    label: string;
    value: string;
    activeColorScheme?: string;
} & Omit<React.ComponentProps<typeof IconButton>, 'icon' | 'aria-label'>;

function ServiceIconButtonRefFunction(
    {
        label,
        value,
        activeColorScheme = 'primary',
        ...props
    }: ServiceIconProps,
    ref: React.ForwardedRef<HTMLInputElement>
) {
    return (
        <IconButton
            ref={ref}
            variant="outline"
            color="muted.300"
            colorScheme="muted"
            bg="white"
            borderColor={ThemeTokens.Defaults.borderColor}
            aria-label={label}
            _checked={{
                borderColor: `${activeColorScheme}.500`,
                bg: `${activeColorScheme}.25`,
                color: `${activeColorScheme}.500`,
            }}
            {...props}
        >
            <ServiceIcon
                service={value}
                height="60%"
            />
        </IconButton>
    );
}

export const ServiceIconButton = forwardRef<ServiceIconProps, 'button'>(ServiceIconButtonRefFunction);
